export default __webpack_public_path__ + "static/media/gallery5.c106ea81.jpg";